import { render, staticRenderFns } from "./sluserviplevel-add-or-update.vue?vue&type=template&id=49ef5ca2&"
import script from "./sluserviplevel-add-or-update.vue?vue&type=script&lang=js&"
export * from "./sluserviplevel-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports